export default __webpack_public_path__ + "static/media/hero-img.dd5b9701.png";